<span class="locale-txt-lang">
  {{ iconText }}
</span>
